import type { Translations } from "../types";

const pl: Translations = {
  "meta.title": "Mapa kliknięć według krajów",
  "meta.description":
    "Interaktywna mapa świata: darmowe kliknięcia dla każdego kraju oraz płatne wsparcie przez Stripe, PayPal i Buy Me a Coffee.",

  "app.title": "Mapa kliknięć według krajów",

  "map.intro":
    "Kliknij kraj na mapie, aby oddać na niego darmowy głos, albo wesprzyj go finansowo - oba sposoby liczą się do łącznego rankingu poniżej. Mapa odzwierciedla wyłącznie wsparcie w tej aplikacji, a nie rzeczywiste bogactwo narodowe czy PKB.",
  "map.verifying": "Weryfikacja …",
  "map.confirmNotRobot": "Zanim dodasz darmowe kliknięcie, szybko potwierdź, że nie jesteś robotem:",
  "map.tryAgain": "Spróbuj ponownie",
  "map.registeringClick": "Rejestrowanie kliknięcia …",
  "map.selectedCountry": "Wybrany kraj: {name}.",
  "map.selectFirstFeedback": "Kraj wybrany. Aby dodać darmowe kliknięcie, najpierw potwierdź poniżej, że nie jesteś robotem.",
  "map.verificationExpired": "Weryfikacja wygasła - potwierdź ponownie, że nie jesteś robotem.",
  "map.slowDown": "Trochę wolniej - poczekaj chwilę przed kolejnym kliknięciem.",
  "map.clickFailed": "Nie udało się zarejestrować kliknięcia. Spróbuj ponownie.",
  "map.clickErrorGeneric": "Błąd podczas rejestrowania kliknięcia.",
  "map.leaderboardHeading": "Ranking krajów",
  "map.emptySelection": "Wybierz kraj na mapie, aby go kliknąć lub wesprzeć.",
  "map.loadingData": "Wczytywanie danych …",

  "worldmap.loadError": "Nie udało się wczytać mapy.",
  "worldmap.resetZoom": "Zresetuj powiększenie",
  "worldmap.resetButton": "⤾ Reset",
  "worldmap.loadingMap": "Wczytywanie mapy …",
  "worldmap.unknownCountry": "Nieznany",
  "worldmap.ariaClicks": "{name}: {clicks} kliknięć",
  "worldmap.tooltipClicks": "{clicks} kliknięć",

  "legend.fewer": "Mniej kliknięć",
  "legend.more": "Więcej kliknięć",

  "list.empty": "Brak kliknięć. Bądź pierwszy!",
  "list.ariaLabel": "Ranking krajów według liczby kliknięć",

  "human.siteKeyMissing": "Nie ustawiono VITE_TURNSTILE_SITE_KEY - zobacz README, aby skonfigurować.",
  "human.verificationFailedGeneric": "Weryfikacja nie powiodła się.",
  "human.networkError":
    "Nie udało się połączyć z weryfikacją (błąd sieci) - sprawdź VITE_SUPABASE_URL, czy funkcja verify-human jest wdrożona, oraz ALLOWED_ORIGIN; zobacz README/NAVODILA.",
  "human.verificationFailedRetry": "Weryfikacja nie powiodła się, spróbuj ponownie.",

  "provider.stripe": "💳 Karta (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Wybrany kraj",
  "panel.currentlyRanked": "Obecnie na miejscu #{rank}",
  "panel.shareCopied": "Skopiowano ✓",
  "panel.shareShared": "Udostępniono ✓",
  "panel.shareButton": "🔗 Udostępnij",

  "panel.tableClicks": "Kliknięcia",
  "panel.tableFree": "Darmowe",
  "panel.tablePaid": "Płatne",
  "panel.rowAllTime": "Od początku",
  "panel.rowThisYear": "W tym roku",
  "panel.rowThisWeek": "W tym tygodniu",
  "panel.rowToday": "Dzisiaj",

  "panel.totalCombined": "Suma łączna:",
  "panel.totalSupport": "Suma wsparcia:",

  "panel.paymentMethod": "Metoda płatności",
  "panel.noPaymentMethod": "Obecnie żadna metoda płatności nie jest dostępna.",
  "panel.supportAmount": "Kwota wsparcia (EUR)",
  "panel.amountRange": "Kwota powinna mieścić się między {min} a {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Szacowane płatne kliknięcia:",
  "panel.ratioInfo":
    "Stosunek: {a} = {b} kliknięć (np. {c} = {d} kliknięć). To tylko szacunek przed płatnością - ostateczna liczba kliknięć jest zawsze obliczana i potwierdzana przez serwer na podstawie faktycznie potwierdzonej płatności.",
  "panel.preparing": "Przygotowywanie …",
  "panel.continueWith": "Kontynuuj z {provider}",
  "panel.choosePaymentMethod": "Wybierz metodę płatności",
  "panel.bmcUsernameMissing": "Nie ustawiono VITE_BMC_USERNAME - zobacz README, aby skonfigurować.",
  "panel.paypalClientIdMissing": "Nie ustawiono VITE_PAYPAL_CLIENT_ID - zobacz README, aby skonfigurować.",

  "panel.paypalAmountInfo": "Kwota: {amount} (szacowane {clicks} kliknięć). Dokończ płatność za pomocą przycisku PayPal poniżej.",
  "panel.back": "← Wstecz",

  "panel.bmcWarningTitle": "⚠️ Zanim przejdziesz do BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Wklej poniższy kod w pole wiadomości/notatki przy płatności — to jedyny sposób, żebyśmy wiedzieli, który kraj wspierasz. Bez kodu nie możemy przypisać płatności do żadnego kraju.",
  "panel.copy": "Kopiuj",
  "panel.copied": "Skopiowano ✓",
  "panel.suggestedAmount": "Sugerowana kwota:",
  "panel.bmcAmountNote":
    "(szacowane {clicks} kliknięć). BuyMeCoffee niestety nie obsługuje przenoszenia kwoty przez link — wpisz/wybierz ją samodzielnie na ich stronie. Rzeczywista liczba kliknięć jest zawsze obliczana na podstawie kwoty faktycznie wysłanej na BuyMeCoffee, a nie na podstawie tego szacunku.",
  "panel.openBmc": "Otwórz BuyMeCoffee i kontynuuj →",
  "panel.waitingProvider": "Oczekiwanie na potwierdzenie płatności od dostawcy płatności …",
  "panel.waitingConfirmation": "Oczekiwanie na potwierdzenie płatności …",
  "panel.timedOut":
    "Przekroczono czas sprawdzania. Jeśli płatność została dokonana, mapa zaktualizuje się po otrzymaniu potwierdzenia przez serwer - czasem może to potrwać nieco dłużej.",
  "panel.checkAgain": "Sprawdź ponownie",

  "panel.cancelled": "Płatność została anulowana lub nie doszła do skutku. Mapa się nie zmieniła.",
  "panel.tryAgain": "Spróbuj ponownie",

  "panel.confirmed": "✅ Wsparcie potwierdzone!",
  "panel.confirmedBody": "{country} otrzymał {clicks} płatnych kliknięć za {amount}.",

  "panel.errorPreparingSupport": "Błąd podczas przygotowywania wsparcia.",
  "panel.errorPreparingPayment": "Błąd podczas przygotowywania płatności.",
  "panel.errorConfirmingPayment": "Błąd podczas potwierdzania płatności.",
  "panel.errorPayingPaypal": "Błąd podczas płatności przez PayPal.",

  "share.unranked": "{flag}{country} potrzebuje Twojego wsparcia na mapie świata!\nPomóż mu wspiąć się w rankingu 👇",
  "share.rank1": "{flag}{country} jest obecnie na 1. miejscu!\nPomóż nam utrzymać pozycję lidera 👇",
  "share.rankN": "{flag}{country} jest obecnie na #{rank} miejscu!\nPomóż nam dotrzeć do #1 👇",

  "language.switcherLabel": "Język",
};

export default pl;
